module.exports = __webpack_public_path__ + "static/media/iot.365b2f80.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/TeamBox/img/iot.svg
// module id = 74
// module chunks = 0